const hasOwn = Object.prototype.hasOwnProperty;

export function isTranslatableLike(item: HashAny): boolean {
  return item && hasOwn.call(item, 'en');
}

export function getTranslatableKeys(item: HashAny) {
  return Object.keys(item).filter(key => {
    return isTranslatableLike(item[key]);
  });
}
